<div class="container-fluid panel">
  <div class="row">
    <div id="menu" class="col-md-2 col-12 sidebar">
      <app-menu></app-menu>
    </div>
    <div id="layout-main" class="col-md-10 col-12 col-12 main-content">
      <div class="alert-style">
        <nexus-alert></nexus-alert>
        <app-modal-carga></app-modal-carga>
      </div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
